import type {SVGProps} from 'react';

import * as React from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="0.8em"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1688_6170)">
      <path d="M4.65548 6.41223H0.640452C0.462258 6.41223 0.317871 6.55668 0.317871 6.73481V19.6334C0.317871 19.8116 0.462258 19.956 0.640452 19.956H4.65548C4.83368 19.956 4.97807 19.8116 4.97807 19.6334V6.73481C4.97807 6.55668 4.83368 6.41223 4.65548 6.41223Z" />
      <path d="M2.64942 0C1.18852 0 0 1.18723 0 2.64652C0 4.10645 1.18852 5.29413 2.64942 5.29413C4.10916 5.29413 5.29671 4.10639 5.29671 2.64652C5.29677 1.18723 4.10916 0 2.64942 0Z" />
      <path d="M14.868 6.09155C13.2555 6.09155 12.0634 6.78478 11.3404 7.57246V6.73471C11.3404 6.55659 11.196 6.41213 11.0178 6.41213H7.17268C6.99448 6.41213 6.8501 6.55659 6.8501 6.73471V19.6333C6.8501 19.8115 6.99448 19.9559 7.17268 19.9559H11.1789C11.3571 19.9559 11.5015 19.8115 11.5015 19.6333V13.2515C11.5015 11.101 12.0856 10.2632 13.5847 10.2632C15.2174 10.2632 15.3471 11.6063 15.3471 13.3621V19.6334C15.3471 19.8116 15.4915 19.9559 15.6697 19.9559H19.6775C19.8556 19.9559 20 19.8116 20 19.6334V12.5583C20 9.36052 19.3903 6.09155 14.868 6.09155Z" />
    </g>
  </svg>
);
export default SvgComponent;
